import { useMemo } from 'react';

import { growerDevicesService } from '../../../../services/growerDevices.service';
import { createApiSlice } from '../../utils/createApiSlice';

const updateGrowerDeviceSlice = createApiSlice({
  reducerPath: ['devices', 'growerDevices', 'updateGrowerDevice'],
  apiFunction: growerDevicesService.updateGrowerDevicesV2
});

const { actions, useApiSelectors } = updateGrowerDeviceSlice;

export const updateGrowerDeviceActions = actions;

export const useUpdateGrowerDeviceSelectors = () => {
  const { inProgress, success, errorMessage, response, updatedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, updatedAt }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default updateGrowerDeviceSlice;
